/* eslint-disable */
require('./3-blocks')
require('./3-dots-rounded')
require('./arrow-down-triangle')
require('./arrow-down')
require('./arrow-left')
require('./arrow-up')
require('./avatar-stroke')
require('./calendar')
require('./camera-plus')
require('./car')
require('./checkmark')
require('./coworker')
require('./enterprise')
require('./expert')
require('./file-plus-csv')
require('./file-plus')
require('./file')
require('./flag-au')
require('./flag-be')
require('./flag-br')
require('./flag-ca')
require('./flag-ch')
require('./flag-de')
require('./flag-en')
require('./flag-es')
require('./flag-fr')
require('./flag-gb')
require('./flag-hk')
require('./flag-ie')
require('./flag-it')
require('./flag-lu')
require('./flag-mx')
require('./flag-nl')
require('./flag-pt')
require('./flag-sg')
require('./flag-us')
require('./gallery-arrow-down')
require('./gallery-arrow-up')
require('./gallery-next')
require('./gallery-prev')
require('./house')
require('./illustration-auto')
require('./illustration-others')
require('./illustration-realty')
require('./list')
require('./mail')
require('./matrix')
require('./minus')
require('./padlock')
require('./pdf')
require('./phone')
require('./plus-boxed')
require('./plus-rounded')
require('./plus')
require('./preview-mail')
require('./preview-model')
require('./preview-report')
require('./pro-badge')
require('./quote')
require('./remove-rounded')
require('./report-double-dash')
require('./report-double')
require('./report-simple')
require('./reports-all')
require('./reports-return')
require('./reports-waiting')
require('./restart')
require('./shield')
require('./specialist')
require('./trash')
require('./wallet-stroke')
require('./weproov-logo')
